import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { FormProvider, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  iframe: {
    width: '100%',
    minHeight: 640,
    border: 0,
  },
  center: {
    alignSelf: 'center',
    justifyContent: 'center',
    display: 'flex',
    marginBottom: theme.spacing(2),
  },
  saveButton: {
    borderRadius: 20,
  },
}));

const Documents = (props) => {
  const { handleNext } = props;
  const classes = useStyles();
  const methods = useForm({});

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <FormProvider {...methods}>
      <div className={classes.root}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <div className={classes.center}>
            <Button variant="contained" color="primary" size="large" className={classes.saveButton} onClick={handleNext} type="submit">
              Guardar Solicitud y Continuar
            </Button>
          </div>
        </form>
      </div>
    </FormProvider>
  );
};

Documents.propTypes = {
  handleNext: PropTypes.any.isRequired,
};

export default Documents;
